/**
 * Excel exports are built by the server (it can read every row, not just the
 * page on screen) and saved here. Fetched rather than navigated to so the same
 * path works in the desktop app, whose webview has no download manager for a
 * navigation to hand the file to.
 */

import { ApiError } from "./api.js";
import { activeWorkspaceHeader, fileUrl, saveBlob } from "./transport.js";

/** "Astrum Connect tasks 2026-10-06.xlsx" — dated in the viewer's own calendar. */
export function excelFileName(kind: string, now: Date = new Date()): string {
  return `Astrum Connect ${kind} ${now.toLocaleDateString("en-CA")}.xlsx`;
}

/** Fetch an `/exports/*.xlsx` route and save the result. `path` starts with `/exports`. */
export async function downloadExcel(path: string, fileName: string): Promise<void> {
  const response = await fetch(fileUrl(`/api/v1${path}`), {
    credentials: "include",
    headers: activeWorkspaceHeader(),
  });
  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as { error?: string; code?: string };
    throw new ApiError(payload.error ?? `Export failed (${response.status})`, response.status, payload.code);
  }
  await saveBlob(await response.blob(), fileName);
}
